
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
// import Select from 'react-select';
import DeveloperMultiSelect from './DeveloperMultiSelect';
import { motion, AnimatePresence } from "framer-motion";
import { MessageSquare, AlertCircle, ChevronDown, ChevronUp } from "react-feather"


import { toast } from 'react-toastify';
import emailjs from '@emailjs/browser';
import StepIndicator from './StepIndicator';
import TicketHistory from './TicketHistory'; // Assurez-vous que le chemin est correct
import Swal from 'sweetalert2';
import progress2 from '../../image/progress2.gif'; // Assurez-vous que le chemin est correct
import logo from "../../image/progress1.gif";
import api from '../../api';



import axios from 'axios';
import {
  Cpu,
  AlertTriangle,
  Layers,
  Users,
  UserCheck,
  ArrowLeft,
  RefreshCw,
  Play,
  Flag,
  Timer ,
  Activity,
  Loader,
  Building,
  Star,
  Calendar,
  User,
  Tag,
  Clock,
  CheckCircle,
  XCircle,
  Edit,
  ChevronRight,
  Info,
  History,
  FileText,
  Paperclip,
  File,
  FolderOpen,
  User as UserIcon,
  Image as ImageIcon,
  ExternalLink,
  ImageOff
} from 'lucide-react';

// Composant de champ éditable compact
const CompactField = ({ 
  label, 
  value, 
  name, 
  type = 'text', 
  icon: Icon, 
  onChange, 
  options = [], 
  multiple = false, 
  disabled = false, 
  error,
  className = '',
  required = false
}) => (
  <div className={`mb-3 ${className}`}>
    <label className="block text-xs font-medium text-gray-600 mb-1">
      <div className="flex items-center">
        {Icon && <Icon size={12} className="text-terrecuite mr-1" />}
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </div>
    </label>
    <div className="relative">
      {type === 'textarea' ? (
        <textarea
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          rows={2}
          className={`w-full border border-gray-200 rounded px-2 py-1 text-gray-700 text-xs focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite ${
            error ? 'border-red-300' : ''
          } ${disabled ? 'bg-gray-50' : 'bg-white'}`}
        />
      ) : type === 'select' ? (
        <select
          name={name}
          multiple={multiple}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full border border-gray-200 rounded px-2 py-1 text-gray-700 text-xs focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite ${
            error ? 'border-red-300' : ''
          } ${disabled ? 'bg-gray-50' : 'bg-white'}`}
        >
          {!multiple && <option value="">--</option>}
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          disabled={disabled}
          className={`w-full border border-gray-200 rounded px-2 py-1 text-gray-700 text-xs focus:outline-none focus:ring-1 focus:ring-terrecuite focus:border-terrecuite ${
            error ? 'border-red-300' : ''
          } ${disabled ? 'bg-gray-50' : 'bg-white'}`}
        />
      )}
      {!disabled && type !== 'select' && type !== 'textarea' && (
        <Edit className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400" size={12} />
      )}
      {error && (
        <p className="mt-1 text-xs text-red-500 flex items-center">
          <AlertCircle size={10} className="mr-1" /> {error}
        </p>
      )}
    </div>
  </div>
);

// Composant de section compact
const CompactSection = ({ title, children, icon: Icon }) => (
  <div className="mb-4">
    <h3 className="text-xs font-semibold text-gray-700 mb-2 flex items-center uppercase tracking-wider">
      {Icon && <Icon size={12} className="text-terrecuite mr-1" />}
      {title}
    </h3>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {children}
    </div>
  </div>
);

export default function TicketDetailCard() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [etapes, setEtapes] = useState([]);
  const [devs, setDevs] = useState([]);
  const [saving, setSaving] = useState(false);
  const statuses = ['nouveau', 'en cours', 'terminé'];
  const [initialDeveloppeurIds, setInitialDeveloppeurIds] = useState([]);
  const [isModified, setIsModified] = useState(false);
  const [utilisateurs, setUtilisateurs] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [isOpenDocuments, setIsOpenDocuments] = useState(true);
  const RETOUR_FONCTIONNEL_ID = "8"; // ID pour l'étape de retour fonctionnel
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [causeText, setCauseText] = useState('');
  const [pendingRetour, setPendingRetour] = useState(false); // active isProcessing
  const [openSections, setOpenSections] = useState({
    bugImage: false,
  });

  const [userId, setUserId] = useState(null); // active isProcessing
  const [module_ids, setModule_ids] = useState(null); // active isProcessing
    useEffect(() => {
    const fetchUser = async () => {
      try {
        const userResponse = await api.get('/me', { withCredentials: true });
        if (!userResponse.data.success) {
          console.error('Impossible de récupérer les informations utilisateur.');
          return;
        }

        const user = userResponse.data.user;
        setUserId(parseInt(user.id, 10));
        setModule_ids(parseInt(user.module_id, 10));
      } catch (error) {
        console.error('Erreur lors de la récupération des informations utilisateur.');
      }
    };

    fetchUser();
  }, []);



  // Définissez la fonction toggleSection
  const toggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const statusMap = {
  1: 'nouveau',
  2: 'en cours',
  3: 'terminé',
};

const statusReverseMap = {
  'nouveau': 1,
  'en cours': 2,
  'terminé': 3,
};



  const [form, setForm] = useState({
    nom: '',
    content: '',
    type: '',
    date_debut_technique: '',
    organisation_id: '',
    deadline_client: '',
    deadline_tech: '',
    date_fin_tech: '',
    priorite: '',
    etape_id: '',
    status: '',
    createur_id: '',
    testeur_id: '',
    affectee_par: '',
    developpeur_ids: [],
    nbr_jrs: '',
    nbr_jrs_valider: '',
    chef_de_projet_id: '',
    last_update: '',
    created_at: '',
    updated_at: '',
    cause_bug: '',
    raison_retour:  '', 
  });

  const isProcessing = pendingRetour;

  const [errors, setErrors] = useState('');
  const [backendErrors, setBackendErrors] = useState({});
  const [activities, setActivities] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenOverview, setIsOpenOverview] = useState(true);
  const [isOpenTech, setIsOpenTech] = useState(true);
  const [isOpenTimeline, setIsOpenTimeline] = useState(true);
  const [isOpenEstimate, setIsOpenEstimate] = useState(true);



  const typeOptions = [
    { value: 'demande', label: 'Demande' },
    { value: 'bug', label: 'Bug' },
  ];

  const priorityOptions = [
    { value: '1', label: 'Faible' },
    { value: '2', label: 'Moyenne' },
    { value: '3', label: 'Haute' },
  ];

  // Simuler des données d'activité
  const mockActivities = [
    {
      id: 1,
      user: 'Admin System',
      action: 'modified',
      field: 'Statut',
      oldValue: 'Nouveau',
      newValue: 'En cours',
      timestamp: '2023-05-15T10:30:00Z'
    },
    {
      id: 2,
      user: 'Jean Dupont',
      action: 'modified',
      field: 'Priorité',
      oldValue: '2',
      newValue: '3',
      timestamp: '2023-05-15T11:45:00Z'
    },
  ];




  useEffect(() => {
    Promise.all([
      api.get(`/tickets/${id}`),
      api.get('/parametrages/etapes'),
      api.get(`/utilisateurs/developpeurs/module/${module_ids}`),
    ])
      .then(([tRes, eRes, dRes]) => {
        setUtilisateurs(dRes.data.developpeurs || []);
        setDocuments(tRes.data.ticket.documents || []);
        const t = tRes.data.ticket;
        setForm({
          nom: t.nom || '',
          content: t.content || '',
          type: t.type || '',
          date_debut_technique: t.date_debut_technique || '',
          organisation_id: t.organisation?.nomOrganisation || '',
          deadline_client: t.deadline_client || '',
          deadline_tech: t.deadline_tech || '',
          date_fin_tech: t.date_fin_tech || '',
          priorite: t.priorite?.toString() || '',
          etape_id: t.etape_id?.toString() || '',
          status: statusMap[t.status] || '',
          createur_nom: t.createur?.nom || '',
          createur_prenom: t.createur?.prenom || '',
          testeur_nom: t.testeur?.nom || '',
          testeur_prenom: t.testeur?.prenom || '',
          affectee_par_nom: t.affectee_par?.nom || '',
          affectee_par_prenom: t.affectee_par?.prenom || '',
          developpeur_ids: t.developpeurs?.map(d => d.utilisateur_id.toString()) || [],
          chef_de_projet_id: t.demande?.chef_de_projet_id?.toString() || '',
          nbr_jrs: t.demande?.nbr_jrs?.toString() || '',
          bug_image_url: t.bug?.image || '',
          nbr_jrs_valider: t.demande?.nbr_jrs_valider?.toString() || '',
          last_update: t.last_update || '',
          module_id: t.module_id || '',
          created_at: t.created_at ? t.created_at.slice(0, 10) : '',
          updated_at: t.updated_at ? t.updated_at.slice(0, 10) : '',
          cause_bug: t.bug?.cause_bug || '',
          raison_retour: t.retours_fonctionnels?.[0]?.raison_retour || '', // ✅ récupère la première raison
        });
        const devIds = t.developpeur_ids || []; // Tableau vide si undefined
        setInitialDeveloppeurIds(devIds.map(String));
        setEtapes(
          eRes.data.etapes
            .slice() // on clone l'array (optionnel mais bon à avoir)
            .sort((a, b) => Number(a.order) - Number(b.order)) // 🧠 tri croissant
            .map(e => ({
              value: e.id.toString(),
              label: e.nom,
              color: e.couleur,
              order: Number(e.order),
            }))
        );
        setDevs(
          dRes.data.developpeurs.map(d => ({
            value: d.utilisateur_id.toString(),
            label: `${d.prenom} ${d.nom}`,
            email: d.email
          }))
        );
        setActivities(mockActivities);
      })
      .catch((e) => setErrors(e.message))
      .finally(() => setLoading(false));
  }, [id]);

const handleChange = (e) => {
  const { name, value, selectedOptions } = e.target;

  const newValue = selectedOptions
    ? Array.from(selectedOptions, (o) => o.value)
    : value;

  setForm((prev) => {
    const updatedForm = {
      ...prev,
      [name]: newValue,
    };

    // Si on change l'étape, on remet le statut à "nouveau"
    if (name === 'etape_id') {
      updatedForm.status = 'nouveau';
    }

    return updatedForm;
    
  });
      setIsModified(true);

};
const ETAPE_LIVREE_ID = "7"; // ID de l'étape "Livrée"

const handleEtapeChange = async (e) => {
  const { value } = e.target;

  if (value === RETOUR_FONCTIONNEL_ID) {
    // Ouvrir modal de retour
    setShowReturnModal(true);
    return;
  }

  if (value === ETAPE_LIVREE_ID) {
    // Confirmation stylisée avec SweetAlert2
    const { isConfirmed } = await Swal.fire({
      title: 'Confirmation',
      text: "Vous êtes sur le point de passer à l'étape 'Livrée'. Confirmez-vous ?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, confirmer',
      cancelButtonText: 'Annuler',
      backdrop: `
        rgba(0,0,0,0.4)
        url("/images/nyan-cat.gif")
        left top
        no-repeat
      `
    });

    if (!isConfirmed) {
      return;
    }

    setForm(prev => ({
      ...prev,
      etape_id: value,
      status: 'nouveau',
      testeur_id: userId ? parseInt(userId, 10) : null,
    }));
  } else {
    setForm(prev => ({
      ...prev,
      etape_id: value,
      status: 'nouveau',
    }));
  }
};


const handleConfirmReject = async () => {
  setPendingRetour(true);

  try {
    await api.post(`/tickets/${id}`, {
      etape_id: parseInt(RETOUR_FONCTIONNEL_ID, 10),
      raison_retour: causeText,
      modifier: userId,
    });

    toast.success("Le ticket a été renvoyé avec succès.");
    setShowReturnModal(false);
    setCauseText('');
    setTimeout(() => window.location.reload(), 500);
  } catch (error) {
    toast.error("Erreur lors du retour fonctionnel.");
  } finally {
    setPendingRetour(false);
  }
};



  const currentStep = form.etape_id;

  const handleSendMessage = () => {
    if (newMessage.trim() === '') return;
    
    const messageActivity = {
      id: activities.length + 1,
      user: 'Utilisateur Actuel',
      action: 'added',
      field: 'Commentaire',
      newValue: newMessage,
      timestamp: new Date().toISOString()
    };
    
    setActivities(prev => [messageActivity, ...prev]);
    setNewMessage('');
  };
  function getNextStatus(current) {
  const idx = statuses.indexOf(current);
  return statuses[(idx + 1) % statuses.length];
}

function handleStatusClick() {
  const next = getNextStatus(form.status);
  setForm(prev => ({ ...prev, status: next }));
}
const statusLabels = {
  'nouveau': { label: 'En attente', bg: 'bg-blue-100', text: 'text-blue-800' },
  'en cours': { label: 'En cours', bg: 'bg-amber-100', text: 'text-amber-800' },
  'terminé': { label: 'Prêt', bg: 'bg-green-100', text: 'text-green-800' },
};
  
  
// 1) Fonction dédiée pour faire tourner le statut
function updateStatus() {
  const next = getNextStatus(form.status);
  setForm(prev => ({ ...prev, status: next }));
}

// 2) handleSave n’affecte plus le statut, il envoie simplement tout form
     const handleSave = async () => {
  setBackendErrors({});
  setIsSaving(true);
  const payload = {};

  // Champs simples
  ['nom', 'content', 'type', 'date_debut_technique', 'deadline_client', 'deadline_tech','date_fin_tech']
    .forEach(key => {
      if (form[key]) payload[key] = form[key];
    });
    if (form.status && statusReverseMap[form.status]) {
  payload.status = statusReverseMap[form.status];
}

  // Champs numériques
  [['priorite', 'priorite'], ['etape_id', 'etape_id']].forEach(([formKey, apiKey]) => {
    if (form[formKey] !== '') {
      payload[apiKey] = parseInt(form[formKey], 10);
    }
  });
  if (form.cause_bug) payload.cause_bug = form.cause_bug;
if (form.raison_retour) payload.raison_retour = form.raison_retour;


  // Développeurs
  if (form.developpeur_ids.length) {
    payload.developpeur_ids = form.developpeur_ids.map(v => parseInt(v, 10));
  }

  // Si type === "demande"
  if (form.type === 'demande') {
    if (form.nbr_jrs)         payload.nbr_jrs = parseInt(form.nbr_jrs, 10);
    if (form.nbr_jrs_valider) payload.nbr_jrs_valider = parseInt(form.nbr_jrs_valider, 10);
    if (form.chef_de_projet_id) payload.chef_de_projet_id = parseInt(form.chef_de_projet_id, 10);
  }

  const currentIds = form.developpeur_ids.map(String).sort();
  const initialIds = initialDeveloppeurIds.map(String).sort();
  const hasChanged = JSON.stringify(currentIds) !== JSON.stringify(initialIds);

  if (hasChanged) {
    payload.affectee_par = userId;
  }
  payload.modifier =  userId;
  
  try {
    await api.post(`/tickets/${id}`, payload);
    
    setIsModified(false); // Désactiver l'indicateur de modifications non sauvegardées
    setIsSaving(false); // Désactiver l'indicateur de chargement

    toast.success('Mis à jour avec succès', {
      position: 'top-right',
      autoClose: 500,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      progress: undefined
    });
    
    setTimeout(() => {
      window.location.reload();
    }, 500);

  } catch (err) {
    setIsSaving(false); // Désactiver l'indicateur de chargement en cas d'erreur
    if (err.response?.status === 422) {
      setBackendErrors(err.response.data.errors || {});
    } else {
      toast.error('Erreur interne du serveur');
      setBackendErrors({ general: 'Une erreur s’est produite. Veuillez réessayer.' });
    }
  }
};





  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-pulse flex items-center">
          <div className="h-6 w-6 bg-terrecuite rounded-full mr-2"></div>
          <span className="text-sm">Chargement en cours...</span>
        </div>
      </div>
    );
  if (errors)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="bg-red-100 border border-red-300 text-red-700 px-3 py-2 rounded flex items-center text-sm">
          <AlertCircle className="mr-2" size={14} />
          <p>{errors}</p>
        </div>
      </div>
    );

    const isRejected = form.status === 'rejeté';
    const statusClass = isRejected
      ? 'bg-red-100 text-red-600'
      : 'bg-green-100 text-green-600';
 
const timelineFields = [
  { label: 'Créé le', name: 'created_at', disabled: true, icon: Calendar },
  { label: 'Dernière modification', name: 'updated_at', disabled: true, icon: RefreshCw },
  { label: 'Début technique', name: 'date_debut_technique', disabled: true, icon: Play },
  { label: 'Fin technique', name: 'date_fin_tech', disabled: true, icon: Clock },
  { label: 'Échéance technique', name: 'deadline_tech', disabled: true, icon: Timer },
  { label: 'Échéance client', name: 'deadline_client', disabled: false, icon: Flag },
];
return (

  
  <div className="flex h-screen overflow-hidden bg-gray-5">
                {isProcessing && (
      <div className="fixed inset-0 bg-black/10 backdrop-blur-sm flex items-center justify-center z-[60]">
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 20 }}
          className="bg-white/90 rounded-xl p-8 shadow-lg border border-terrecuite-100 max-w-sm w-full mx-4"
        >
          <div className="flex flex-col items-center text-center space-y-5">
            {/* Logo animé avec conteneur ajusté */}
    <motion.div 
              className="w-20 h-20 mb-3"
              animate={{ 
                scale: [1, 1.1, 1]
              }}
              transition={{
                scale: {
                  duration: 2,
                  repeat: Infinity,
                  repeatType: "reverse"
                }
              }}
            >
              <img 
                src={logo}
                alt="Chargement en cours"
                className="w-full h-full object-contain"
              />
            </motion.div>
            
            {/* Texte avec hiérarchie visuelle améliorée */}
            <div className="space-y-2">
              <h3 className="text-lg font-medium text-terrecuite-700">
                Traitement en cours...
              </h3>
              <p className="text-terrecuite-500/90 text-sm leading-relaxed">
                Nous traitons votre demande, merci de patienter.
              </p>
            </div>
    
            {/* Barre de progression subtile avec plus de transparence */}
            <div className="w-full bg-terrecuite-100/50 rounded-full h-1.5 mt-2">
              <motion.div
                className="bg-terrecuite-500/80 h-full rounded-full"
                initial={{ width: 0 }}
                animate={{ width: ["0%", "70%", "100%", "0%"] }}
                transition={{ 
                  duration: 3, 
                  repeat: Infinity, 
                  ease: "easeInOut" 
                }}
              />
            </div>
          </div>
        </motion.div>
      </div>
    )}
          {showReturnModal && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="bg-white rounded-lg p-6 max-w-md w-full mx-4"
        >
          <div className="flex items-center mb-4">
            <span className="text-red-500 text-xl mr-3">⚠</span>
            <h3 className="text-lg font-semibold text-gray-800">Retour Fonctionnel</h3>
          </div>
          <p className="text-gray-600 mb-3">
            Veuillez saisir une raison pour retourner le ticket <strong>"{form.nom}"</strong>.
          </p>
    
          <textarea
            className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 text-sm focus:outline-none focus:ring-2 focus:ring-red-300 resize-none"
            rows={4}
            placeholder="Raison du retour..."
            value={causeText}
            onChange={(e) => setCauseText(e.target.value)}
            disabled={isProcessing}
          />
    
          <div className="flex justify-end space-x-3">
            <button
              onClick={() => { setShowReturnModal(false); setCauseText(''); }}
              disabled={isProcessing}
              className="px-4 py-2 text-gray-600 bg-gray-100 rounded-lg hover:bg-gray-200"
            >
              Annuler
            </button>
<button
  disabled={!causeText.trim() || isProcessing}
  onClick={handleConfirmReject}
  className={`px-4 py-2 text-white rounded-lg transition-colors flex items-center gap-2 ${
    causeText.trim() && !isProcessing
      ? "bg-red-600 hover:bg-red-700"
      : "bg-red-300 cursor-not-allowed"
  }`}
>

              {isProcessing ? (
                <>
                  <motion.div
                    className="w-4 h-4 border-2 border-white border-t-transparent rounded-full"
                    animate={{ rotate: 360 }}
                    transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
                  />
                  Traitement...
                </>
              ) : (
                "Retourner"
              )}
            </button>
          </div>
        </motion.div>
      </div>
    )}
        {isModified && (
      <div className="fixed bottom-4 right-4 z-50">
        <div className="bg-white p-3 rounded-full shadow-lg flex items-center">
          <img src={progress2} alt="Saving" className="w-8 h-8 mr-2" />
          <span className="text-sm font-medium text-gray-700">Modifications non enregistrées</span>
        </div>
      </div>
    )}

    {/* Colonne de gauche - Détails du ticket (70% de largeur) */}
    <div className="w-full lg:w-[75%] h-full overflow-y-auto">
      {/* En-tête */}
<div className="bg-white shadow-sm">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="py-3 md:py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-b border-gray-200">
      {/* Section gauche: Bouton retour et informations ticket */}
      <div className="flex flex-col xs:flex-row items-start xs:items-center gap-2 xs:gap-4 w-full sm:w-auto">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center text-gray-600 hover:text-gray-900 transition-colors duration-200"
        >
          <ArrowLeft size={20} className="mr-1 md:mr-2" />
          <span className="font-medium text-sm md:text-base">Retour</span>
        </button>

        <div className="flex flex-col xs:flex-row xs:items-center gap-2 xs:gap-4">
          <h1 className="text-xl md:text-2xl font-semibold text-gray-900 whitespace-nowrap">
            Ticket #{id}
          </h1>
          <span
            onClick={handleStatusClick}
            className={`self-start xs:self-auto inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium cursor-pointer transition ${statusLabels[form.status]?.bg || 'bg-gray-100'
              } ${statusLabels[form.status]?.text || 'text-gray-800'}`}
          >
            {statusLabels[form.status]?.label || 'Inconnu'}
          </span>
        </div>
      </div>

      {/* Section droite: Boutons d'action */}
      <div className="flex items-center justify-end xs:justify-start gap-2 w-full sm:w-auto">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center px-3 py-1.5 md:px-4 md:py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none"
        >
          Annuler
        </button>
        <button
          onClick={handleSave}
          disabled={isSaving}
          className={`inline-flex items-center px-3 py-1.5 md:px-4 md:py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none ${isSaving ? 'opacity-75 cursor-not-allowed' : ''
            }`}
        >
          {isSaving ? (
            <>
              <img src={logo} alt="Chargement..." className="w-4 h-4 md:w-5 md:h-5 mr-1 md:mr-2 animate-spin" />
              <span className="hidden xs:inline">Enregistrement...</span>
              <span className="xs:hidden">...</span>
            </>
          ) : (
            <>
              <CheckCircle size={16} className="mr-1 md:mr-2 md:size-[18px]" />
              <span className="hidden xs:inline">Enregistrer</span>
              <span className="xs:hidden">Enregistrer</span>
            </>
          )}
        </button>
      </div>
    </div>
  </div>
</div>

      {/* Indicateur de progression */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <StepIndicator 
            etapes={etapes} 
            currentStep={form.etape_id} 
            className="py-3"
            activeColor="indigo-600"
          />
        </div>
      </div>

      {/* Contenu principal */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="space-y-6">
          {form.type === 'bug' ? (
  // Afficher uniquement Vue d'ensemble, Détails techniques, Chronologie
  <>
    <div className="space-y-8">
      {/* Vue d'ensemble */}
            <motion.div 
              initial={{ opacity: 1 }}
              className="bg-white shadow rounded-2xl p-4"            >
              <motion.div 
                className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenOverview(!isOpenOverview)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
                    <MessageSquare size={18} className="mr-2 text-gray-500" />
                    Vue d'ensemble
                  </h3>
                  {isOpenOverview ? (
                    <ChevronUp size={18} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={18} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenOverview && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-4 py-4 sm:p-5">
                      <div className="space-y-4">
                        <div>
                          <label htmlFor="nom" className="block text-sm font-medium text-gray-700 mb-1">
                            Titre <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="nom"
                            id="nom"
                            value={form.nom}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            placeholder="Saisissez le titre du ticket..."
                            disabled
                          />
                          {backendErrors.nom?.[0] && (
                            <p className="mt-1 text-xs text-red-600 flex items-center">
                              <AlertCircle size={14} className="mr-1" />
                              {backendErrors.nom[0]}
                            </p>
                          )}
                        </div>
                        
                        <div>
                          <label htmlFor="content" className="block text-sm font-medium text-gray-700 mb-1">
                            Description
                          </label>
                          <textarea
                            name="content"
                            id="content"
                            rows={3}
                            value={form.content}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            placeholder="Décrivez les détails du ticket..."
                            
                          />
                          {backendErrors.content?.[0] && (
                            <p className="mt-1 text-xs text-red-600 flex items-center">
                              <AlertCircle size={14} className="mr-1" />
                              {backendErrors.content[0]}
                            </p>
                          )}
                        </div>
                          <CompactField
                          label="cause de bug"
                          name="cause_bug"
                          type="textarea"
                          value={form.cause_bug}
                          onChange={handleChange}
                          icon={AlertTriangle}
                          disabled
                        />

                        <div>
                          <label htmlFor="Organisation" className="block text-sm font-medium text-gray-700 mb-1">
                            Organisation <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="Organisation"
                            id="Organisation"
                            value={form.organisation_id}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            placeholder="Saisissez l'organisation..."
                            disabled 
                          />
                          {backendErrors.nom?.[0] && (
                            <p className="mt-1 text-xs text-red-600 flex items-center">
                              <AlertCircle size={14} className="mr-1" />
                              {backendErrors.nom[0]}
                            </p>
                          )}
                        </div>
<div className="flex gap-4">
  <div className="flex-1">
    <label htmlFor="testeur" className="block text-sm font-medium text-gray-700 mb-1">
      Testeur
    </label>
    <input
      type="text"
      id="testeur"
      value={`${form.testeur_nom} ${form.testeur_prenom}`}
      disabled
      className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
    />
  </div>

  <div className="flex-1">
    <label htmlFor="createur" className="block text-sm font-medium text-gray-700 mb-1">
      Créateur
    </label>
    <input
      type="text"
      id="createur"
      value={`${form.createur_nom} ${form.createur_prenom}`}
      disabled
      className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
    />
  </div>
</div>


                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
      {/* Détails techniques */}
            <motion.div className="bg-white shadow rounded-2xl p-4">
              <motion.div 
                className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenTech(!isOpenTech)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
                    <Cpu size={18} className="mr-2 text-gray-500" />
                    Détails techniques
                  </h3>
                  {isOpenTech ? (
                    <ChevronUp size={18} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={18} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenTech && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-4 py-4 sm:p-5">
                      <div className="space-y-4">
                        <div>
                          <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                            Type <span className="text-red-500">*</span>
                          </label>
                          <select
                            name="type"
                            id="type"
                            value={form.type}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            disabled
                          >
                            <option value="">Sélectionnez un type...</option>
                            {typeOptions.map(opt => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                          {backendErrors.type?.[0] && (
                            <p className="mt-1 text-xs text-red-600">
                              {backendErrors.type[0]}
                            </p>
                          )}
                        </div>

                        <div>
                          <label htmlFor="priorite" className="block text-sm font-medium text-gray-700 mb-1">
                            Priorité
                          </label>
                          <select
                            name="priorite"
                            id="priorite"
                            value={form.priorite}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                          >
                            <option value="">Sélectionnez une priorité...</option>
                            {priorityOptions.map(opt => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label htmlFor="etape_id" className="block text-sm font-medium text-gray-700 mb-1">
                            Étape
                          </label>
                              <select
                                name="etape_id"
                                id="etape_id"
                                value={form.etape_id}
                                onChange={handleEtapeChange}  // <-- ici
                                className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                              >
                                <option value="">Sélectionnez une étape...</option>
                                {etapes.map(opt => (
                                  <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                  </option>
                                ))}
                              </select>
                        </div>
                        <div>
                          <DeveloperMultiSelect
                              options={devs}
                              value={form.developpeur_ids}
                              onChange={handleChange}
                              error={backendErrors.developpeur_ids?.[0]}
                            />
                          </div>
                                                    <CompactField
                          label="Raison Retour"
                          name="raison_retour"
                          type="textarea"
                          value={form.raison_retour}
                          onChange={handleChange}
                          icon={AlertTriangle}
                          disabled
                        />
                      </div>
                    </div>
                  </motion.div>
                )}
                
              </AnimatePresence>

            </motion.div>

      {/* Chronologie uniquement */}
            <motion.div className="bg-white shadow rounded-2xl p-4">
              <motion.div 
                className="px-3 py-2 sm:px-4 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenTimeline(!isOpenTimeline)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-sm leading-5 font-medium text-gray-900 flex items-center">
                    <Calendar size={16} className="mr-2 text-gray-500" />
                    Chronologie & Échéances
                  </h3>
                  {isOpenTimeline ? (
                    <ChevronUp size={16} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={16} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenTimeline && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-3 py-2 sm:px-4">
                      <div className="space-y-3">
                        {timelineFields.map(field => (
                          <div key={field.name} className="flex flex-col sm:flex-row sm:items-center gap-2">
                            <label className="block text-xs font-medium text-gray-700 w-full sm:w-1/3 flex items-center min-w-[120px]">
                              <field.icon size={14} className="inline mr-1.5" />
                              {field.label}
                            </label>
                            <div className="w-full sm:w-2/3">
                              <input
                                type="date"
                                name={field.name}
                                value={form[field.name] || ''}
                                onChange={handleChange}
                                disabled={field.disabled}
                                className={`block w-full px-2 py-1.5 text-xs border rounded-md shadow-sm ${
                                  field.disabled 
                                    ? 'bg-gray-50 border-gray-200 text-gray-500 cursor-not-allowed' 
                                    : 'border-gray-300 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500'
                                }`}
                              />
                              {backendErrors[field.name]?.[0] && (
                                <p className="mt-1 text-xs text-red-600">
                                  {backendErrors[field.name][0]}
                                </p>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>  

 
              
            




      </div>
      {/* document */}
      <div className="bg-white shadow rounded-2xl p-4">
  <motion.div 
    className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
    onClick={() => setIsOpenDocuments(!isOpenDocuments)}
  >
    <div className="flex items-center justify-between">
      <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
        <Paperclip size={18} className="mr-2 text-gray-500" />
        Documents joints
      </h3>
      {isOpenDocuments ? (
        <ChevronUp size={18} className="text-gray-500" />
      ) : (
        <ChevronDown size={18} className="text-gray-500" />
      )}
    </div>
  </motion.div>

  <AnimatePresence>
    {isOpenDocuments && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="px-4 py-4 sm:p-5">
          {documents.length === 0 ? (
            <div className="text-center py-4">
              <FolderOpen size={24} className="mx-auto text-gray-400" />
              <p className="mt-2 text-sm text-gray-500">Aucun document joint</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {documents.map((doc) => (
                <div 
                  key={doc.id} 
                  className="border border-gray-200 rounded-lg p-4 hover:border-indigo-300 transition-colors group"
                >
                  <div className="flex items-start">
                    <div className="bg-indigo-50 p-3 rounded-lg mr-4">
                      <FileText size={24} className="text-indigo-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <a
                        href={doc.document_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-medium text-gray-900 hover:text-indigo-600 block truncate"
                        title={doc.document_url.split('/').pop()}
                      >
                        {doc.document_name}
                      </a>
                      <p className="text-xs text-gray-500 mt-1">
                        {doc.utilisateur_id ? (
                          <span className="inline-flex items-center">
                            <User size={12} className="mr-1" />
                            Utilisateur #{doc.utilisateur_id}
                          </span>
                        ) : (
                          <span className="inline-flex items-center">
                            <Cpu size={12} className="mr-1" />
                            Automatique
                          </span>
                        )}
                      </p>
                      <div className="mt-2">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                          {doc.document_url.split('.').pop().toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    )}
  </AnimatePresence>
</div>
{/* Capture du bug - JUSTE ICI APRÈS LA CHRONOLOGIE */}
{form.type === 'bug' && (
  <motion.div className="bg-white shadow rounded-2xl p-4"> {/* Retiré mt-6 */}
    <motion.div 
      className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
      onClick={() => toggleSection('bugImage')}
    >
      <div className="flex items-center justify-between">
        <h3 className="text-sm leading-5 font-medium text-gray-900 flex items-center">
          <ImageIcon size={16} className="mr-2 text-gray-500" />
          Capture du bug
        </h3>
        {openSections.bugImage ? (
          <ChevronUp size={16} className="text-gray-500" />
        ) : (
          <ChevronDown size={16} className="text-gray-500" />
        )}
      </div>
    </motion.div>

    <AnimatePresence>
      {openSections.bugImage && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.2 }}
        >
          <div className="px-3 py-2 sm:px-4">
            {form.bug_image_url ? (
              <div className="flex flex-col items-center space-y-3">
                <img 
                  src={form.bug_image_url} 
                  alt="Capture du bug" 
                  className="max-w-full h-auto rounded-lg border border-gray-200"
                />
                <a 
                  href={form.bug_image_url} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-sm text-gray-600 hover:text-gray-800 flex items-center"
                >
                  <ExternalLink size={14} className="mr-1" />
                  Voir en grand
                </a>
              </div>
            ) : (
              <div className="text-center py-4">
                <ImageOff size={24} className="mx-auto text-gray-400" />
                <p className="mt-2 text-sm text-gray-500">Aucune image de bug disponible</p>
              </div>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  </motion.div>
)}
      </div>
  </>
) : (
  // Sinon, afficher tout comme d’habitude
  <>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
            {/* Carte de vue d'ensemble */}
            <motion.div 
              initial={{ opacity: 1 }}
              className="bg-white shadow rounded-2xl p-4"            >
              <motion.div 
                className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenOverview(!isOpenOverview)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
                    <MessageSquare size={18} className="mr-2 text-gray-500" />
                    Vue d'ensemble
                  </h3>
                  {isOpenOverview ? (
                    <ChevronUp size={18} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={18} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenOverview && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-4 py-4 sm:p-5">
                      <div className="space-y-4">
                        <div>
                          <label htmlFor="nom" className="block text-sm font-medium text-gray-700 mb-1">
                            Titre <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="nom"
                            id="nom"
                            value={form.nom}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            placeholder="Saisissez le titre du ticket..."
                            disabled
                          />
                          {backendErrors.nom?.[0] && (
                            <p className="mt-1 text-xs text-red-600 flex items-center">
                              <AlertCircle size={14} className="mr-1" />
                              {backendErrors.nom[0]}
                            </p>
                          )}
                        </div>
                        
                        <div>
                          <label htmlFor="content" className="block text-sm font-medium text-gray-700 mb-1">
                            Description
                          </label>
                          <textarea
                            name="content"
                            id="content"
                            rows={3}
                            value={form.content}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            placeholder="Décrivez les détails du ticket..."
                            
                          />
                          {backendErrors.content?.[0] && (
                            <p className="mt-1 text-xs text-red-600 flex items-center">
                              <AlertCircle size={14} className="mr-1" />
                              {backendErrors.content[0]}
                            </p>
                          )}
                        </div>
                         

                        <div>
                          <label htmlFor="Organisation" className="block text-sm font-medium text-gray-700 mb-1">
                            Organisation <span className="text-red-500">*</span>
                          </label>
                          <input
                            type="text"
                            name="Organisation"
                            id="Organisation"
                            value={form.organisation_id}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            placeholder="Saisissez l'organisation..."
                            disabled 
                          />
                          {backendErrors.nom?.[0] && (
                            <p className="mt-1 text-xs text-red-600 flex items-center">
                              <AlertCircle size={14} className="mr-1" />
                              {backendErrors.nom[0]}
                            </p>
                          )}
                        </div>
<div className="flex gap-4">
  <div className="flex-1">
    <label htmlFor="testeur" className="block text-sm font-medium text-gray-700 mb-1">
      Testeur
    </label>
    <input
      type="text"
      id="testeur"
      value={`${form.testeur_nom} ${form.testeur_prenom}`}
      disabled
      className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
    />
  </div>

  <div className="flex-1">
    <label htmlFor="createur" className="block text-sm font-medium text-gray-700 mb-1">
      Créateur
    </label>
    <input
      type="text"
      id="createur"
      value={`${form.createur_nom} ${form.createur_prenom}`}
      disabled
      className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-gray-100 text-gray-700"
    />
  </div>
</div>


                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>

            {/* Détails techniques */}
            <motion.div className="bg-white shadow rounded-2xl p-4">
              <motion.div 
                className="px-3 py-2 sm:px-4 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenTech(!isOpenTech)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
                    <Cpu size={18} className="mr-2 text-gray-500" />
                    Détails techniques
                  </h3>
                  {isOpenTech ? (
                    <ChevronUp size={18} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={18} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenTech && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-4 py-4 sm:p-5">
                      <div className="space-y-4">
                        <div>
                          <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                            Type <span className="text-red-500">*</span>
                          </label>
                          <select
                            name="type"
                            id="type"
                            value={form.type}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            disabled
                          >
                            <option value="">Sélectionnez un type...</option>
                            {typeOptions.map(opt => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                          {backendErrors.type?.[0] && (
                            <p className="mt-1 text-xs text-red-600">
                              {backendErrors.type[0]}
                            </p>
                          )}
                        </div>

                        <div>
                          <label htmlFor="priorite" className="block text-sm font-medium text-gray-700 mb-1">
                            Priorité
                          </label>
                          <select
                            name="priorite"
                            id="priorite"
                            value={form.priorite}
                            onChange={handleChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                          >
                            <option value="">Sélectionnez une priorité...</option>
                            {priorityOptions.map(opt => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <label htmlFor="etape_id" className="block text-sm font-medium text-gray-700 mb-1">
                            Étape
                          </label>
                          <select
                            name="etape_id"
                            id="etape_id"
                            value={form.etape_id}
                            onChange={handleEtapeChange}
                            className="block w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                          >
                            <option value="">Sélectionnez une étape...</option>
                            {etapes.map(opt => (
                              <option key={opt.value} value={opt.value}>
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div>
                          <DeveloperMultiSelect
                              options={devs}
                              value={form.developpeur_ids}
                              onChange={handleChange}
                              error={backendErrors.developpeur_ids?.[0]}
                            />
                          </div>
                                                                   <CompactField
                          label="Raison Retour"
                          name="raison_retour"
                          type="textarea"
                          value={form.raison_retour}
                          onChange={handleChange}
                          icon={AlertTriangle}
                          disabled
                        />
                      </div>
                    </div>
                  </motion.div>
                )}
 
              </AnimatePresence>
              
            </motion.div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 items-start">
            {/* Chronologie */}
            <motion.div className="bg-white shadow rounded-2xl p-4">
              <motion.div 
                className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenTimeline(!isOpenTimeline)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-sm leading-5 font-medium text-gray-900 flex items-center">
                    <Calendar size={16} className="mr-2 text-gray-500" />
                    Chronologie & Échéances
                  </h3>
                  {isOpenTimeline ? (
                    <ChevronUp size={16} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={16} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenTimeline && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-3 py-2 sm:px-4">
                      <div className="space-y-3">
                        {timelineFields.map(field => (
                          <div key={field.name} className="flex flex-col sm:flex-row sm:items-center gap-2">
                            <label className="block text-xs font-medium text-gray-700 w-full sm:w-1/3 flex items-center min-w-[120px]">
                              <field.icon size={14} className="inline mr-1.5" />
                              {field.label}
                            </label>
                            <div className="w-full sm:w-2/3">
                              <input
                                type="date"
                                name={field.name}
                                value={form[field.name] || ''}
                                onChange={handleChange}
                                disabled={field.disabled}
                                className={`block w-full px-2 py-1.5 text-xs border rounded-md shadow-sm ${
                                  field.disabled 
                                    ? 'bg-gray-50 border-gray-200 text-gray-500 cursor-not-allowed' 
                                    : 'border-gray-300 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500'
                                }`}
                              />
                              {backendErrors[field.name]?.[0] && (
                                <p className="mt-1 text-xs text-red-600">
                                  {backendErrors[field.name][0]}
                                </p>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>



            {/* Estimation de temps */}
            <motion.div className="bg-white shadow rounded-2xl p-4">
              <motion.div 
                className="px-3 py-2 sm:px-4 border-b border-gray-200 cursor-pointer"
                onClick={() => setIsOpenEstimate(!isOpenEstimate)}
              >
                <div className="flex items-center justify-between">
                  <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
                    <Clock size={18} className="mr-2 text-gray-500" />
                    Estimation de temps
                  </h3>
                  {isOpenEstimate ? (
                    <ChevronUp size={18} className="text-gray-500" />
                  ) : (
                    <ChevronDown size={18} className="text-gray-500" />
                  )}
                </div>
              </motion.div>

              <AnimatePresence>
                {isOpenEstimate && (
                  <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <div className="px-4 py-4 sm:p-5">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
                          <h3 className="text-xs font-medium text-gray-700 mb-1 flex items-center">
                            <Clock size={14} className="mr-1.5" />
                            Jours estimés
                          </h3>
                          <div className="text-xl font-semibold text-gray-900">
                            {form.nbr_jrs || <span className="text-gray-400">N/A</span>}
                          </div>
                        </div>
                        
                        <div className="bg-gray-50 p-3 rounded-md border border-gray-200">
                          <h3 className="text-xs font-medium text-gray-700 mb-1 flex items-center">
                            <CheckCircle size={14} className="mr-1.5" />
                            Jours validés
                          </h3>
                          <div className="text-xl font-semibold text-gray-900">
                            {form.nbr_jrs_valider || <span className="text-gray-400">N/A</span>}
                          </div>
                        </div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          </div>
            {/* document */}
<div className="bg-white shadow rounded-2xl p-4">
  <motion.div 
    className="px-4 py-3 sm:px-5 border-b border-gray-200 cursor-pointer"
    onClick={() => setIsOpenDocuments(!isOpenDocuments)}
  >
    <div className="flex items-center justify-between">
      <h3 className="text-md leading-6 font-medium text-gray-900 flex items-center">
        <Paperclip size={18} className="mr-2 text-gray-500" />
        Documents joints
      </h3>
      {isOpenDocuments ? (
        <ChevronUp size={18} className="text-gray-500" />
      ) : (
        <ChevronDown size={18} className="text-gray-500" />
      )}
    </div>
  </motion.div>

  <AnimatePresence>
    {isOpenDocuments && (
      <motion.div
        initial={{ opacity: 0, height: 0 }}
        animate={{ opacity: 1, height: "auto" }}
        exit={{ opacity: 0, height: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="px-4 py-4 sm:p-5">
          {documents.length === 0 ? (
            <div className="text-center py-4">
              <FolderOpen size={24} className="mx-auto text-gray-400" />
              <p className="mt-2 text-sm text-gray-500">Aucun document joint</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              {documents.map((doc) => (
                <div 
                  key={doc.id} 
                  className="border border-gray-200 rounded-lg p-4 hover:border-indigo-300 transition-colors group"
                >
                  <div className="flex items-start">
                    <div className="bg-indigo-50 p-3 rounded-lg mr-4">
                      <FileText size={24} className="text-indigo-600" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <a
                        href={doc.document_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-medium text-gray-900 hover:text-indigo-600 block truncate"
                        title={doc.document_url.split('/').pop()}
                      >
                        {doc.document_url.split('/').pop()}
                      </a>
                      <p className="text-xs text-gray-500 mt-1">
                        {doc.utilisateur_id ? (
                          <span className="inline-flex items-center">
                            <User size={12} className="mr-1" />
                            Utilisateur #{doc.utilisateur_id}
                          </span>
                        ) : (
                          <span className="inline-flex items-center">
                            <Cpu size={12} className="mr-1" />
                            Automatique
                          </span>
                        )}
                      </p>
                      <div className="mt-2">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                          {doc.document_url.split('.').pop().toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </motion.div>
    )}
  </AnimatePresence>
</div>
  </>
)}

        </div>
      </div>
    </div>

    {/* Colonne de droite - Historique (30% de largeur) */}
<div className="hidden lg:block w-full lg:w-[30%] h-full border-l border-gray-200 bg-white overflow-hidden">
  <div className="h-full">
    <TicketHistory ticketId={id} userId={userId} />
  </div>
</div>
  </div>
);
}